import { createFileRoute } from '@tanstack/react-router';
import { TiersListPage } from '@/features/tiers/tiers-list-page.js';

export const Route = createFileRoute('/_app/settings/tiers')({
  component: TiersListPage,
});
